import NavTabs from "@/components/NavTabs/NavTabs";
import { AUTHORITIES } from "@/config/constants";
import { useSetPageTitle } from "@/context/PageTitleContext";
import { Users, UserCircle, GraduationCap } from "lucide-react";
import { Navigate, Route, Routes } from "react-router-dom";
import FriendsList from "./FriendsList";

const AmiciRoutes = () => {
  useSetPageTitle("I miei amici", "Studenti e docenti con cui hai stretto amicizia");
  return (
    <div className="px-4 py-6 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-5xl">
        <div className="space-y-4">
          <div className="overflow-hidden rounded-3xl">
            <div
              className="flex flex-col justify-center bg-cover bg-center px-6 py-12 text-white"
              style={{
                backgroundImage:
                  'linear-gradient(to right top, rgba(100, 115, 201, 0.7), rgba(25, 32, 72, 0.7)), url("/class.jpg")',
                minHeight: "200px",
              }}
            >
              <h1 className="mb-1 text-heading font-semibold">I miei amici</h1>
              <p className="text-body text-white/90">
                Studenti e docenti con cui hai stretto amicizia
              </p>
            </div>
            <NavTabs
              tabs={[
                {
                  label: "Tutti",
                  icon: <Users className="h-5 w-5" />,
                  iconPosition: "top",
                  href: "/friends/all",
                },
                {
                  label: "Studenti",
                  icon: <UserCircle className="h-5 w-5" />,
                  iconPosition: "top",
                  href: "/friends/students",
                },
                {
                  label: "Docenti",
                  icon: <GraduationCap className="h-5 w-5" />,
                  iconPosition: "top",
                  href: "/friends/teachers",
                },
              ]}
            />
          </div>
          <Routes>
            <Route index element={<Navigate replace to="all" />} />
            <Route
              path="all"
              element={
                <FriendsList roleFilter={null} title="Tutti i miei amici" />
              }
            />
            <Route
              path="teachers"
              element={
                <FriendsList
                  roleFilter={AUTHORITIES.ROLE_TEACHER}
                  title="Docenti"
                />
              }
            />
            <Route
              path="students"
              element={
                <FriendsList
                  roleFilter={AUTHORITIES.ROLE_STUDENT}
                  title="Studenti"
                />
              }
            />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default AmiciRoutes;
